import { useState } from "react";
import { Dialog } from "@headlessui/react";

import { AlertTriangleIcon, Modal } from "@prequel/shared-components";

const CONFIRMATION_TEXT = "delete all data";

type ConfirmFullRefreshModalProps = {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmFullRefreshModal = ({ show, onClose, onConfirm }: ConfirmFullRefreshModalProps) => {
  const [inputValue, setInputValue] = useState("");

  const submitEnabled = inputValue === CONFIRMATION_TEXT;

  const resetState = () => {
    setInputValue("");
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleConfirm = () => {
    if (!submitEnabled) {
      return;
    }
    resetState();
    onConfirm();
  };

  return (
    <Modal open={show} onClose={handleClose}>
      <div className="sm:flex sm:items-start">
        <div
          className="
            mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100
            sm:mx-0 sm:size-10
          "
        >
          <AlertTriangleIcon className="size-6 text-red-400" />
        </div>
        <div
          className="
            mt-3 text-center
            sm:mt-0 sm:ml-4 sm:text-left
          "
        >
          <Dialog.Title as="h3" className="text-lg/6 font-medium text-gray-900">
            Force full refresh
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Are you sure you want to force a full data refresh for this destination? This will delete all existing
              data in the destination and re-sync all available data. This process may take a while.
            </p>
          </div>
          <div className="mt-4">
            <p className="text-sm text-gray-500">
              Please type <span className="font-semibold text-gray-700">{CONFIRMATION_TEXT}</span> to confirm.
            </p>
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className="
                mt-2 block w-full rounded-md border-gray-300 shadow-sm
                focus:border-primary-500 focus:ring-primary-500
                sm:text-sm
              "
              placeholder={CONFIRMATION_TEXT}
            />
          </div>
        </div>
      </div>
      <div
        className="
          mt-5
          sm:mt-4 sm:ml-10 sm:flex sm:pl-4
        "
      >
        <button
          type="button"
          disabled={!submitEnabled}
          className="
            inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base
            font-medium text-white shadow-sm
            hover:bg-red-700
            focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:outline-none
            disabled:cursor-not-allowed disabled:opacity-50
            sm:w-auto sm:text-sm
          "
          onClick={handleConfirm}
        >
          Force full refresh
        </button>
        <button
          type="button"
          className="
            mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base
            font-medium text-gray-700 shadow-sm
            hover:bg-gray-50
            focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:outline-none
            sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
          "
          onClick={handleClose}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmFullRefreshModal;
